// extracted by mini-css-extract-plugin
export default {"container":"_37Gfg","icon":"MeK7u","text":"yAZi9"};